module.exports = __webpack_public_path__ + "img/arcade_small.64a52952.webp";